import { render, staticRenderFns } from "./DataTablePaginator.vue?vue&type=template&id=1a476982"
import script from "./DataTablePaginator.vue?vue&type=script&lang=js"
export * from "./DataTablePaginator.vue?vue&type=script&lang=js"
import style0 from "./DataTablePaginator.vue?vue&type=style&index=0&id=1a476982&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports